import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';

gsap.registerPlugin(ScrollTrigger);

function newsGridTitle() {
    var title = $qs('.js-slide-over-title');

    gsap.fromTo(title, {
        xPercent: 70,        
    }, {
        xPercent: -50,
        scrollTrigger: {
            trigger : title ,
            scrub: 1.4,
            start: `top bottom-=200px`
        }
    })
}

function newsSlider() {
    console.log('news-slider');
    const swiper = new Swiper('[data-target=news-slider]', {

        modules: [Pagination, Autoplay, EffectFade],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },        
        slidesPerView: 1,
        // slidesPerGroup: 1,
        autoHeight: true,
        // slidesPerColumn: 1,
        spaceBetween: 0,
        speed: 1000,
        breakpoints: {
            // md
            728: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                slidesPerColumn: 1,
            },
        },
    });

}
function newsGrid() {
    newsGridTitle();
    newsSlider()
}

export default newsGrid;